module.exports = __webpack_public_path__ + "static/img/xz0417.e3d8887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xz0417.jpg
// module id = uloV
// module chunks = 0